'use strict'

module.exports = {
    '(1 - strokewidth % 2) / 2'(strokewidth) { return (1 - strokewidth % 2) / 2 }
}